import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row mt-3 mb-2" }
const _hoisted_2 = {
  class: "row",
  "data-masonry": "{\"percentPosition\": true }"
}
const _hoisted_3 = {
  key: 0,
  class: "col-sm-6 col-lg-4 mb-4"
}

import { navigationConfig } from "@/shared/config";
import {
  userShouldSeeApp,
  userShouldSeeGroup,
} from "@/shared/services/navigation";
import NavAppName from "@/shared/components/nav/NavAppName.vue";
import NavGroupCard from "@/shared/components/nav/NavGroupCard.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'NavMasonry',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _directive_masonry = _resolveDirective("masonry")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navigationConfig), (app) => {
    return (_openBlock(), _createElementBlock(_Fragment, {
      key: app.title
    }, [
      (_unref(userShouldSeeApp)(app))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("h3", null, [
                _createVNode(NavAppName, {
                  title: app.title,
                  icon: app.icon
                }, null, 8, ["title", "icon"])
              ])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(app.items, (group) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: group.title
                }, [
                  (_unref(userShouldSeeGroup)(group))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(NavGroupCard, { group: group }, null, 8, ["group"])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])), [
              [_directive_masonry, _ctx.containerId]
            ])
          ], 64))
        : _createCommentVNode("", true)
    ], 64))
  }), 128))
}
}

})